import { render, staticRenderFns } from "./ProfessionalPracticeTermsTable.vue?vue&type=template&id=cc5cb450"
import script from "./ProfessionalPracticeTermsTable.vue?vue&type=script&lang=js"
export * from "./ProfessionalPracticeTermsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports